var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "email-history-details-body" }, [
    _c("div", { staticClass: "choose-event-wrapper row" }, [
      _c("div", { staticClass: "col-md-3" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Event Type")]),
        _vm._v(" "),
        _c("div", { staticClass: "event-type" }, [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.historyDetails.singleEvent == true
                  ? "Single Event"
                  : "Related Event (" +
                      _vm.historyDetails.relatedEvents.length +
                      " events)"
              ) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-md-5" }, [
        _c("div", { staticClass: "h4-text" }, [_vm._v("Events")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "group-related-events" },
          _vm._l(_vm.historyDetails.relatedEvents, function(reEvent) {
            return _c(
              "div",
              { key: reEvent.id, staticClass: "related-event-item" },
              [
                _c(
                  "div",
                  {
                    staticClass: "event-name",
                    on: {
                      click: function($event) {
                        _vm.relatedEventItemClick(reEvent.id)
                      }
                    }
                  },
                  [_vm._v(_vm._s(reEvent.eventName))]
                )
              ]
            )
          })
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "recipients-wrapper row" }, [
      _c("div", { staticClass: "recipients-section col-md-8" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Recipients (To)")]),
        _vm._v(" "),
        _c("div", { staticClass: "list-email-recipient" }, [
          _c("div", { staticClass: "list-email-send-to" }, [
            _vm.listEmailSendTo.length == 0
              ? _c("div", { staticClass: "body-text" }, [
                  _vm._v("\n            N/A\n          ")
                ])
              : _c(
                  "div",
                  _vm._l(_vm.listEmailSendTo, function(e) {
                    return _c("div", { key: e, staticClass: "email-item" }, [
                      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))])
                    ])
                  })
                )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "cc-section col-md-4" }, [
        _c("div", { staticClass: "h3-text" }, [
          _vm._v("Additional Recipients (CC)")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-email-recipient" }, [
          _c("div", { staticClass: "list-email-send-to" }, [
            _vm.listEmailCC.length == 0
              ? _c("div", { staticClass: "body-text" }, [
                  _vm._v("\n            N/A\n          ")
                ])
              : _c(
                  "div",
                  _vm._l(_vm.listEmailCC, function(e) {
                    return _c("div", { key: e, staticClass: "email-item" }, [
                      _c("div", { staticClass: "text" }, [_vm._v(_vm._s(e))])
                    ])
                  })
                )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "email-template-wrapper" }, [
      _c("div", { staticClass: "choose-email-template" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Email Template")]),
        _vm._v(" "),
        _c("div", { staticClass: "template-value body-text" }, [
          _vm._v(
            "\n        " +
              _vm._s(_vm._f("templateName")(_vm.historyDetails.templateType)) +
              "\n      "
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "email-body-section" }, [
        _c("div", { staticClass: "h3-text" }, [_vm._v("Email Body")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "row email-body-container ck-for-email-history-detail"
          },
          [
            _c(
              "div",
              { staticClass: "col-md-8" },
              [
                _c("vue-ckeditor", {
                  attrs: { config: _vm.config },
                  on: { focus: _vm.ckEditorFocus },
                  model: {
                    value: _vm.historyDetails.templateBody,
                    callback: function($$v) {
                      _vm.$set(_vm.historyDetails, "templateBody", $$v)
                    },
                    expression: "historyDetails.templateBody"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "reply-and-history-section col-md-4" }, [
              _c("div", { staticClass: "reply-emails-wrapper" }, [
                _c("div", { staticClass: "h4-text" }, [
                  _vm._v("Reply emails go to:")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "list-email-recipient" }, [
                  _c("div", { staticClass: "list-email-send-to" }, [
                    _vm.listReplyEmails.length == 0
                      ? _c("div", { staticClass: "body-text" }, [_vm._v("N/A")])
                      : _c(
                          "div",
                          _vm._l(_vm.listReplyEmails, function(e) {
                            return _c(
                              "div",
                              { key: e, staticClass: "email-item" },
                              [
                                _c("div", { staticClass: "text" }, [
                                  _vm._v(_vm._s(e))
                                ])
                              ]
                            )
                          })
                        )
                  ])
                ])
              ])
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-444f447e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-444f447e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/events/EmailHistoryDetails.vue
// module id = 1840
// module chunks = 1